import styled from 'styled-components';

import { rem } from '../../utils/units';

export const StyledLabel = styled.label<{ disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const StyledRoot = styled.div`
  input[type='radio'],
  input[type='checkbox'] {
    display: none;
  }
`;

const StyledSharedFlex = styled.div`
  user-select: none;
  display: flex;
`;

export const StyledFlexWrapper = styled(StyledSharedFlex)`
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  justify-content: space-between;
  align-items: center;
`;

export const StyledFlex = styled(StyledSharedFlex)`
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  align-items: center;
`;

export const StyledVericalFlex = styled(StyledSharedFlex)`
  flex-direction: column;
`;
